import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import { ShaDowBox } from "../../../../../components/boxes";
import { getData, formatDatetime } from "../../../../../services";
import { LinearChartPart, NoDataCard } from "../../../../../components/parts";
import { comparisonChartLines, comparisonGraphFooter } from "../../../constants";

export const PowerConsumptionComparison = ({ tId }) => {
  const { id } = useParams();
  const title = "Avg. Power Consumption Comparison";
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    getData(`/praas/v2/buildings/${id}/tenants/${tId}/consumption-comparison/`, (results) => {
      setChartData(
        results.map((result) => ({
          x: formatDatetime(new Date(result.date), "YYYY-M"),
          avg_industry: result.industry_consumption,
          building: result.building_consumption,
          avg_portfolio: result.portfolio_consumption,
          tenant: result.tenant_consumption,
        }))
      );
    });
    return () => setChartData([]);
  }, []);

  if (!chartData.length) {
    return (
      <NoDataCard
        title={title}
        footerNames={comparisonGraphFooter.map((item) => item.name)}
        type="line"
      />
    );
  }

  return (
    <ShaDowBox fullHeight>
      <LinearChartPart
        title={title}
        chartData={chartData}
        chartLines={comparisonChartLines}
        graphFooterItems={comparisonGraphFooter}
      />
    </ShaDowBox>
  );
};
